const NAMESPACE = "externalDataShared";

const KEYS = {
    errorHeader: "errorHeader",
    warningHeader: "warningHeader",
    infoHeader: "infoHeader",
    validationSuccessTitle: "validationSuccessTitle",
    validationFailureTitle: "validationFailureTitle",
    validationAdditionalMessagesText: "validationAdditionalMessagesText",
    validationDownloadLinkText: "validationDownloadLinkText"
};

const MESSAGES = {
    [KEYS.errorHeader]: {
        value: "Validation Errors:",
        comment: "Header for a list of errors from validating uploaded data."
    },
    [KEYS.warningHeader]: {
        value: "Validation Warnings:",
        comment: "Header for a list of warnings from validating uploaded data."
    },
    [KEYS.infoHeader]: {
        value: "Validation Info:",
        comment: "Header for a list of informational messages from validating uploaded data."
    },
    [KEYS.validationSuccessTitle]: {
        value: "Validation Succeeded",
        comment: "Validation success title"
    },
    [KEYS.validationFailureTitle]: {
        value: "Validation Failed",
        comment: "Validation failure header"
    },
    [KEYS.validationAdditionalMessagesText]: {
        value: "An additional {number} messages were not displayed.",
        comment: "Text that displays when there are more messages than can be shown in the UI."
    },
    [KEYS.validationDownloadLinkText]: {
        value: "Download as text file",
        comment: "Text for a link to download a file containing all validation messages."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
